import QueryParamsUtil from 'api/utils/query-params-util'
import axios from 'axios'

const API_PATH = 'api/v2/admins/merchants/outbounds/returns'

const MerchantOutboundReturnsApiV2 = {
  /**
   * Get list of `Merchant Outbound Returns`
   * @param {object} tableState - ReactTable final state
   */
  get: async ({ tableState }) => {
    const params = QueryParamsUtil.format(tableState)
    const path   = API_PATH

    const response = await axios.get(path, { params })
    return response
  },

  /**
   * Show Merchant Outbound Return by specific id
   * Inovke `GET api/v2/admins/merchants/outbounds/returns/:id`
   * @param {number} id Merchant Inbound's ID
   */
  show: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = axios.get(path)
    return response
  },

  /**
   * Get list of `Merchant Outbound Return Items`
   * @param {object} tableState - ReactTable final state
   */
  getItems: async ({ tableState, id }) => {
    const params = QueryParamsUtil.format(tableState)
    const path   = `${API_PATH}/${id}/items`

    const response = await axios.get(path, { params })
    return response
  },

  /**
   * Invoke `PATCH api/v2/admins/merchants/outbounds/returns/:id`
   */
  update: async (id, update_values) => {
    const path     = `${API_PATH}/${id}`
    const body     = {
      outbound_return: update_values
    }
    const response = axios.patch(path, body)
    return response
  },

  /**
   * Invoke `PATCH api/v2/admins/merchants/outbounds/returns/:id/ship`
   */
  ship: async (id) => {
    const path     = `${API_PATH}/${id}/ship`
    const response = axios.patch(path)
    return response
  },

  /**
   * Create `Merchant::Outbound::Return`
   * @param {object} params new `Merchant::Outbound::Return`
   * @return {object} Object of `Merchant::Outbound::Return`
   */
  create: async (params) => {
    const body     = {
      outbound_return: params
    }
    const path     = API_PATH
    const response = axios.post(path, body)
    return response
  }

}

export default MerchantOutboundReturnsApiV2
